/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {StickyHeaderSimpleButtonComponent} from './html-elements/sticky-header-simple-button.component';
import {StickyHeaderIconButtonComponent} from './html-elements/sticky-header-icon-button.component';

@Injectable({
    providedIn: 'root'
})
export class StickyHeaderService {
    mainActionSubject = new Subject<StickyHeaderSimpleButtonComponent>();
    mainActionObservable = this.mainActionSubject.asObservable();

    contextActionsSubject = new Subject<StickyHeaderIconButtonComponent[]>();
    contextActionsObservable = this.contextActionsSubject.asObservable();

    searchActionSubject = new Subject<StickyHeaderSimpleButtonComponent>();
    searchActionObservable = this.searchActionSubject.asObservable();

    submitActionSubject = new Subject<StickyHeaderSimpleButtonComponent>();
    submitActionObservable = this.submitActionSubject.asObservable();

    constructor() {
    }

    registerMainAction(action: StickyHeaderSimpleButtonComponent): void {
        this.mainActionSubject.next(action);
    }

    registerContextActions(actions: StickyHeaderIconButtonComponent[]): void {
        this.contextActionsSubject.next(actions);
    }

    registerSearchAction(action: StickyHeaderSimpleButtonComponent): void {
        this.searchActionSubject.next(action);
    }

    registerSubmitAction(action: StickyHeaderSimpleButtonComponent): void {
        this.submitActionSubject.next(action);
    }

    clearActions(): void {
        this.registerMainAction(null);
        this.registerContextActions([]);
        this.registerSearchAction(null);
        this.registerSubmitAction(null);
    }
}
